import React from 'react';
import Fields from 'ui/form/FieldsForm';
import { CalendarToday } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '-50px 0 0',
    },
    wrapper: {
        width: '300px',
        display: 'flex',
    },
    buttonBox: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 16px 10px',
    },
});

function Filters({ classes, selectedOption, options, onChange }) {
    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                <div className={classes.buttonBox}>
                    <CalendarToday />
                </div>
                <Fields.Select
                    value={selectedOption}
                    options={options}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}

Filters.propTypes = {};

export default withStyles(styles)(Filters);
